module.exports = __webpack_public_path__ + "static/whosOnWhat-2d32eab811a3158a815a7298347f122e.jpg";